import { render, staticRenderFns } from "./BaseDadosNacional.vue?vue&type=template&id=03958134&"
import script from "./BaseDadosNacional.vue?vue&type=script&lang=js&"
export * from "./BaseDadosNacional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports